// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search[data-v-0f19f2f0]{margin:40px 0}.v-list__tile__title.timeout[data-v-0f19f2f0]{color:#ff0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
